<script>
import DashboardOss from '@/components/dashboard/Oss.vue'
import DashboardSicantik from '@/components/dashboard/Sicantik.vue'
import DashboardSimbg from '@/components/dashboard/Simbg.vue'
import DashboardPengaduan from '@/components/dashboard/Pengaduan.vue'
import DashboardSkmMpp from '@/components/dashboard/SkmMpp.vue'
import DashboardSkmDpmptsp from '@/components/dashboard/SkmDpmptsp.vue'
import DashboardMppDigital from '@/components/dashboard/MppDigital.vue'
import DashboardLkpm from '@/components/dashboard/Lkpm.vue'

export default {
   components: {
      DashboardOss,
      DashboardSicantik,
      DashboardSimbg,
      DashboardPengaduan,
      DashboardSkmMpp,
      DashboardSkmDpmptsp,
      DashboardMppDigital,
      DashboardLkpm,
   },
}
</script>

<template>
   <div>
      <DashboardOss />
      <DashboardLkpm />
      <DashboardSimbg />
      <DashboardMppDigital />
      <DashboardSicantik />
      <DashboardSkmDpmptsp />
      <DashboardSkmMpp />
      <DashboardPengaduan />

   </div>
</template>

<style scoped></style>
